import { Component } from "@theme/component";

class ShopAllCollectionsComponent extends Component {
  requiredRefs = ["collections", "count"];

  connectedCallback() {
    super.connectedCallback();
    this.activeCategory = "all";
    this.activeScent = "all";
    this.activeSort = "relevance";
    this.applyFilters();
  }

  handleCategoryFilterClick(event) {
    const item = event.target.closest("li");
    const filterGroup = event.target.closest("[data-type='category']");
    if (!item || !filterGroup || !item.dataset.handle) return;

    this.activeCategory = item.dataset.handle;
    this.moveFilterItemToTop(item, filterGroup);
    this.applyFilters();
  }

  handleScentClick(event) {
    const item = event.target.closest("li");
    const filterGroup = event.target.closest("[data-type='scent']");
    if (!item || !filterGroup || !item.dataset.handle) return;

    this.activeScent = item.dataset.handle;
    this.moveFilterItemToTop(item, filterGroup);
    this.applyFilters();
  }

  handleSortClick(event) {
    const item = event.target.closest("li");
    const filterGroup = event.target.closest("[data-type='sort']");
    if (!item || !filterGroup || !item.dataset.handle) return;

    this.activeSort = item.dataset.handle;
    this.moveFilterItemToTop(item, filterGroup);
    this.applyFilters();
  }

  moveFilterItemToTop(item, filterGroup) {
    const list = filterGroup.querySelector(".collections-list-filters-options");
    if (list && item.parentElement === list) {
      list.prepend(item);
    }
    filterGroup.querySelector("ul")?.blur();
  }

  applyFilters() {
    let totalVisible = 0;

    this.refs.collections.forEach((collection) => {
      const matchesCategory =
        this.activeCategory === "all" ||
        collection.dataset.handle === this.activeCategory;

      collection.classList.toggle("hidden", !matchesCategory);

      if (!matchesCategory) return;

      collection.filterScent(this.activeScent);
      collection.sortProducts(this.activeSort);

      const visibleCount = collection.visibleProductCount();
      collection.classList.toggle("scent_hidden", visibleCount === 0);
      totalVisible += visibleCount;
    });

    this.updateCount(totalVisible);
  }

  updateCount(count) {
    if (!this.refs.count) return;
    const label = count === 1 ? "Product" : "Products";
    this.refs.count.textContent = `Displaying ${count} ${label}`;
  }
}

if (!customElements.get("shop-all-collections-component")) {
  customElements.define(
    "shop-all-collections-component",
    ShopAllCollectionsComponent,
  );
}
